import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import TechButton from "./TechButton";
const ProjectCard = ({ data }) => {
  return (
    <a href={data.link} target="_blank" className="date">
      <div className="ProjectCard">
        <div className="inforamtion">
          <div className="header">
            <span className="projectname">{data.name}</span>
          </div>
          {data.description && <div className=" project-description hideoncondition">{data.description}</div>}
        </div>

        <div className="image ">
          <img src={data.imageLink} className="imagetag"></img>
        </div>
      </div>
    </a>
  );
};

export default ProjectCard;
